// ─── Motion vocabulary ──────────────────────────────────────────────────────
// Material motion in a business register: quick, precise, critically damped.
// Entrances carry a little depth — blocks tilt up out of the page as they
// rise, headlines lift out of a mask — but nothing bounces or spins. The
// names are kept from the earlier expressive system so call sites stay put.

export const SPRING = {
  // Entrances and indicators: firm, at most a hair of overshoot.
  bouncy: { type: 'spring', stiffness: 420, damping: 40, mass: 1 },
  // Hover and tab switches: crisp, no overshoot.
  snappy: { type: 'spring', stiffness: 700, damping: 52, mass: 1 },
  // Large panels and sheets: a longer, still-damped settle.
  gentle: { type: 'spring', stiffness: 260, damping: 34, mass: 1 },
  // Opacity and colour.
  effects: { type: 'spring', stiffness: 1600, damping: 80, mass: 1 },
}

export const EASE = [0.2, 0, 0, 1] // Material "emphasized"
export const EASE_OUT = [0.05, 0.7, 0.1, 1] // "emphasized decelerate"

// Scroll-triggered entrance: the block rises and tilts up out of the page,
// as if hinged at its foot, settling flat as it arrives.
export const rise = (delay = 0, y = 28) => ({
  hidden: { opacity: 0, y: Math.min(y, 32), rotateX: 9, transformPerspective: 1100 },
  show: {
    opacity: 1,
    y: 0,
    rotateX: 0,
    transformPerspective: 1100,
    transition: { duration: 0.8, ease: EASE_OUT, delay, opacity: { duration: 0.5, ease: EASE, delay } },
  },
})

// Fade-in for chips, icons, dots.
export const pop = (delay = 0) => ({
  hidden: { opacity: 0, scale: 0.94 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.4, ease: EASE_OUT, delay } },
})

// Parent that staggers its children's `hidden` → `show`.
export const stagger = (each = 0.06, delayChildren = 0) => ({
  hidden: {},
  show: { transition: { staggerChildren: each, delayChildren } },
})

// Headlines: each word lifts out of its own mask.
export const wordSwing = {
  hidden: { y: '105%' },
  show: { y: 0, transition: { duration: 0.75, ease: EASE_OUT } },
}

// A hairline that draws itself from the left.
export const drawLine = (delay = 0) => ({
  hidden: { scaleX: 0 },
  show: { scaleX: 1, transition: { duration: 1, ease: EASE_OUT, delay } },
})

export const VIEWPORT = { once: true, margin: '0px 0px -12% 0px' }
